package com.iptvplayer.shared.db

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class VodItemEntity(
  public val id: String,
  public val sourceId: String,
  public val name: String,
  public val streamUrl: String,
  public val coverUrl: String?,
  public val plot: String?,
  public val genre: String?,
  public val duration: Long?,
  public val rating: Double?,
  public val groupName: String?,
)
